export default import.meta.ROLLUP_FILE_URL_Wp2WuxumjkKk3Ol6yU8IPQ